module.exports = __webpack_public_path__ + "static/media/suraj.563d4435.jpeg";